import React from "react";
import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { TID } from "@/lib/testIds";

export default function DeleteConfirmDialog({
  open,
  onOpenChange,
  task,
  onConfirm,
  submitting,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-[#E2E8F0]">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[#0F172A]">
            Delete this task?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#64748B]">
            <span className="font-medium text-[#0F172A]">
              {task?.title || "This task"}
            </span>{" "}
            will be permanently removed along with any attached document. This
            action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={submitting}
            data-testid={TID.deleteCancel}
            className="border-[#E2E8F0]"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={submitting}
            className="bg-[#DC2626] hover:bg-[#B91C1C] text-white"
            data-testid={TID.deleteConfirm}
          >
            {submitting && (
              <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" />
            )}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
